import { ReactElement } from 'react'
import { Box, Card, Typography } from '@mui/material'
import { AssignmentStatsData } from '../types'

type AssignmentStatsProps = {
  stats: AssignmentStatsData
}

export default function AssignmentStats({
  stats,
}: AssignmentStatsProps): ReactElement {
  return (
    <Box
      className="grid grid-cols-1 gap-4 mb-6 sm:grid-cols-3"
      role="region"
      aria-label="Assignment statistics"
    >
      <Card
        sx={{
          p: 3,
          backgroundColor: 'background.paperDark',
          border: '1px solid',
          borderColor: 'divider',
          textAlign: 'center',
        }}
        role="article"
        aria-label="Active assignments count"
      >
        <Typography
          color="primary.main"
          variant="h3"
          sx={{
            fontWeight: 700,
            mb: 1,
            fontSize: '2.5rem',
          }}
          aria-label={`${stats.active} active assignments`}
        >
          {stats.active}
        </Typography>
        <Typography color="text.secondary" variant="body2" aria-hidden="true">
          Active
        </Typography>
      </Card>
      <Card
        sx={{
          p: 3,
          backgroundColor: 'background.paperDark',
          border: '1px solid',
          borderColor: 'divider',
          textAlign: 'center',
        }}
        role="article"
        aria-label="Completed assignments count"
      >
        <Typography
          color="success.main"
          variant="h3"
          sx={{
            fontWeight: 700,
            mb: 1,
            fontSize: '2.5rem',
          }}
          aria-label={`${stats.completed} completed assignments`}
        >
          {stats.completed}
        </Typography>
        <Typography color="text.secondary" variant="body2" aria-hidden="true">
          Completed
        </Typography>
      </Card>
      <Card
        sx={{
          p: 3,
          backgroundColor: 'background.paperDark',
          border: '1px solid',
          borderColor: 'divider',
          textAlign: 'center',
        }}
        role="article"
        aria-label="Overdue assignments count"
      >
        <Typography
          color="error.main"
          variant="h3"
          sx={{
            fontWeight: 700,
            mb: 1,
            fontSize: '2.5rem',
          }}
          aria-label={`${stats.overdue} overdue assignments`}
        >
          {stats.overdue}
        </Typography>
        <Typography color="text.secondary" variant="body2" aria-hidden="true">
          Overdue
        </Typography>
      </Card>
    </Box>
  )
}
